module.exports = "/images/FillingDisclosure.png?522e34c8a26e5cd2b214dfae487842b9";